import { useMemo } from 'react';
import { useFormik } from 'formik';
import { useIntl } from 'react-intl';
import useGroupLabels from '~/modules/common/components/Groups/hooks/useGroupLabels';
import {
  initialState,
  validationSchema,
  mapFormikValuesToWithForm
} from '~/modules/projects/resourcing-plan/ResourceRequestChart/components/ResourceRequestDrawer/hooks/useResourceRequestDrawerForm';

export const useInitialState = ({
  project,
  defaultRequestAttributeWeights,
  baseCurrency,
  isPsaRmpEnhancedProjectManagerPersonaEnabled
}) => {
  const { requestedCostRate, ...attributeWeights } =
    defaultRequestAttributeWeights || {};

  return useMemo(
    () =>
      initialState({
        project,
        resourceRequest: {
          location: isPsaRmpEnhancedProjectManagerPersonaEnabled
            ? project.defaultGroupRestrictions?.location
            : project.location,
          costCenter: isPsaRmpEnhancedProjectManagerPersonaEnabled
            ? project.defaultGroupRestrictions?.costCenter
            : project.costCenter,
          division: isPsaRmpEnhancedProjectManagerPersonaEnabled
            ? project.defaultGroupRestrictions?.division
            : project.division,
          department: isPsaRmpEnhancedProjectManagerPersonaEnabled
            ? project.defaultGroupRestrictions?.department
            : project.department,
          serviceCenter: isPsaRmpEnhancedProjectManagerPersonaEnabled
            ? project.defaultGroupRestrictions?.serviceCenter
            : project.serviceCenter,
          employeeType: isPsaRmpEnhancedProjectManagerPersonaEnabled
            ? project.defaultGroupRestrictions?.employeeType
            : project.employeeType,
          currency: project.budgetedCost?.currency || baseCurrency
        },
        defaultRequestAttributeWeights: {
          ...attributeWeights,
          requestedCostRate
        }
      }),
    [
      project,
      attributeWeights,
      baseCurrency,
      requestedCostRate,
      isPsaRmpEnhancedProjectManagerPersonaEnabled
    ]
  );
};

export const useAddResourceRequestForm = ({
  project,
  defaultRequestAttributeWeights,
  baseCurrency,
  isPsaRmpEnhancedProjectManagerPersonaEnabled
}) => {
  const intl = useIntl();

  const initialValues = useInitialState({
    project,
    defaultRequestAttributeWeights,
    baseCurrency,
    isPsaRmpEnhancedProjectManagerPersonaEnabled
  });

  const groupLabels = useGroupLabels();

  const formik = useFormik({
    initialValues,
    validationSchema: validationSchema({ intl, groupLabels }),
    enableReinitialize: true,
    validateOnMount: true
  });

  return useMemo(() => mapFormikValuesToWithForm(formik), [formik]);
};

export default useAddResourceRequestForm;
